import { Component, OnInit } from '@angular/core';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
declare var getHexAscii: any;

@Component({
  selector: 'app-imps-transfer',
  templateUrl: './imps-transfer.component.html',
  styleUrls: ['./imps-transfer.component.css']
})
export class ImpsTransferComponent implements OnInit {
  userName: string;
  impsP2AOrP2P: any = '';
  isLoad: boolean;
  payeeListImps: any;
  nickNameImps: any = '';
  toAccountNoImps: any = '';
  ifsccdImps: any;
  mobileNoImps: any;
  mmidImps: any;
  fromAccountNoImps: any ='';
  amountImps: any;
  narrationImps: any;
  isShowImps: string = 'page';
  otpImps: any;
  accountNo: any;
  message: string;
  scoAccounts: any = [];

  regSpeci = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regchar = '/^[a-zA-Z]+$/';
  regexpspace = /\s+/;
  regZeroOnly = '^[0][0]*[0]$';
  //regNum = /^.*[0-9]/;
  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum = /^[0-9]+$/;

  regexcap = /^.*?[A-Z]/;
  curRegExp = /^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/;
  NextBtnDisabled : boolean = false;
  ImpsP2AOrP2PValidate: string;
  disabled: boolean;
  ImpsfromAccountNoValidate: string;
  nickNameImpsValidate: string;
  amountNotlankImps: string;
  amountmessageForSpaceImps: string;
  amountZeroOnlyImps: string;
  notValidAmmountImps: string;
  narrationValidateImps: string;
  otpImpsValidate: string;
  otpdisablereq: boolean;
  error: string;
  isTrue: string;
  showAcctBalance: string;
  showAllTransaction: string;
  accountInfo: any;
  transactionList: any;
  greterThanZero: string;
  SubBtnDisabled : boolean = false;
  bankName: any;

  constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService) {
    this.bankName = webService.getBankName();

    this.userName =sessionStorage.getItem('storedUserName');
    this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
  }

  ngOnInit() {
   
    }


  
  isP2AOrP2P() {
    this.error = '';
    if (this.userName && this.impsP2AOrP2P) {
       this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.userName + this.impsP2AOrP2P);
      request.param2 = this.userName;
      request.param3 = this.impsP2AOrP2P;

      this.webService.getResponse(request, 'getPayeeForImps').subscribe((data: IbResponse) => {
        response = data;
        this.isLoad = false;
         this.spinnerService.hide();
        if (response !== null && response.status === 'S200') {
          this.payeeListImps = response.param6;
          this.isShowImps = 'page1';
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  getToAccountNoImps() {
    this.error = '';
    for (let i = 0; i < this.payeeListImps.length; i++) {
      if (this.payeeListImps[i].nickname === this.nickNameImps) {
        if (this.impsP2AOrP2P === 'P2A') {
          this.toAccountNoImps = this.payeeListImps[i].acctno;
          this.ifsccdImps = this.payeeListImps[i].ifsccd;
        }
        if (this.impsP2AOrP2P === 'P2P') {
          this.mobileNoImps = this.payeeListImps[i].mobileno;
          this.mmidImps = this.payeeListImps[i].mmid;
        }
      }
    }
  }

  getOtpImps() {
   
    this.error = '';
    this.allValidation();
    if (this.fromAccountNoImps && ((this.toAccountNoImps && this.amountImps) || (this.mobileNoImps && this.mmidImps)) && this.narrationImps && this.disabled === false) {
     this.spinnerService.show();
     this.NextBtnDisabled=true;
     const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.userName);
      request.param2 = this.userName;
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // console.log('Otp :' + response.param1);
          this.isShowImps = 'page2';
          this.otpImps='';
          this.error='';
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
          this.NextBtnDisabled=false;
        }
      });
    }
  }
impsFundTransferRequest() {
    this.SubBtnDisabled=true;
    this.error = '';
    if (this.fromAccountNoImps && ((this.toAccountNoImps && this.amountImps) || (this.mobileNoImps && this.mmidImps)) && this.narrationImps && this.otpImps && this.disabled === false
    && this.getIMPSOTPValid()) {
      this.isLoad = false;
       this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      if (this.impsP2AOrP2P === 'P2A') {
        const otpDetails: any = {
          'userName': this.userName,
          'otp':  getHexAscii('',this.otpImps),
          'imps': this.impsP2AOrP2P,
          'creditIfscCd': this.ifsccdImps,
          'creditNickName': this.nickNameImps
        };
        //request.param1 = getHexAscii('', this.fromAccountNoImps + this.toAccountNoImps + this.amountImps + this.narrationImps + this.userName + this.otpImps + this.impsP2AOrP2P + this.ifsccdImps + this.nickNameImps);
       request.param1 = getHexAscii('', this.fromAccountNoImps + this.toAccountNoImps + this.amountImps + this.narrationImps + this.userName + this.otpImps);// + this.impsP2AOrP2P + this.ifsccdImps + this.nickNameImps);

        request.param2 = this.fromAccountNoImps;
        request.param3 = this.toAccountNoImps;
        request.param4 = this.amountImps;
        request.param5 = this.narrationImps;
        request.param6 = otpDetails;
      }
      if (this.impsP2AOrP2P === 'P2P') {
        const otpDetails: any = {
          'userName': this.userName,
          'otp': getHexAscii('', this.otpImps),
          'imps': this.impsP2AOrP2P,
          'mmid': this.mmidImps,
          'creditNickName': this.nickNameImps,
          'mobileno':sessionStorage.getItem('mobileno'),
          'custno':sessionStorage.getItem('custNo')
        };

        request.param1 = getHexAscii('', this.fromAccountNoImps + this.mobileNoImps + this.amountImps + this.narrationImps +this.userName+this.otpImps);//+this.impsP2AOrP2P+this.mmidImps+this.nickNameImps);
       // request.param1 = getHexAscii('', this.fromAccountNoImps + this.mobileNoImps + this.amountImps + this.narrationImps );
        console.log(this.fromAccountNoImps + this.mobileNoImps + this.amountImps + this.narrationImps +this.userName+this.otpImps);
        request.param2 = this.fromAccountNoImps;
        request.param3 = this.mobileNoImps;
        request.param4 = this.amountImps;
        request.param5 = this.narrationImps;
        request.param6 = otpDetails;
      }
      this.webService.getResponse(request, 'impsFundTransfer').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          this.accountNo = this.fromAccountNoImps;
          //this.showTransaction();
           this.isShowImps='page3';
                    this.error = "Your transaction  completed successfully for Rs. "+ this.amountImps + " to account No : "+this.toAccountNoImps + " With Reference No :" + response.param1;

         
        }else if (response != null && (response.status==='S333' || response.status==='S334') ) {
          this.error= response.param1;
          this.SubBtnDisabled=true;
        }  else if (response !== null) {
          this.SubBtnDisabled=false;
          this.error ='Your transaction is declined for Rs.'+this.amountImps+' due to '+ response.param1;
        } else {
           this.SubBtnDisabled=false;
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }
 /* impsFundTransferRequest() {
    this.SubBtnDisabled=true;
    this.error = '';
    if (this.fromAccountNoImps && ((this.toAccountNoImps && this.amountImps) || (this.mobileNoImps && this.mmidImps)) && this.narrationImps && this.otpImps && this.disabled === false) {
      this.spinnerService.show();
      this.isLoad = false;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      if (this.impsP2AOrP2P === 'P2A') {
        const otpDetails: any = {
          'userName': this.userName,
          'otp': this.otpImps,
          //'imps': this.impsP2AOrP2P,
          'imps': 'p2a',
          'creditIfscCd': this.ifsccdImps,
          'creditNickName': this.nickNameImps
        };
        request.param1 = getHexAscii('', this.fromAccountNoImps + this.toAccountNoImps + this.amountImps + this.narrationImps + this.userName + this.otpImps + this.impsP2AOrP2P + this.ifsccdImps + this.nickNameImps);
        request.param2 = this.fromAccountNoImps;
        request.param3 = this.toAccountNoImps;
        request.param4 = this.amountImps;
        request.param5 = this.narrationImps;
        request.param6 = otpDetails;
      }
      if (this.impsP2AOrP2P === 'P2P') {
        const otpDetails: any = {
          'userName': this.userName,
          'otp': this.otpImps,
          'imps': this.impsP2AOrP2P,
          'mmid': this.mmidImps,
          'creditNickName': this.nickNameImps
        };

        request.param1 = getHexAscii('', this.fromAccountNoImps + this.mobileNoImps + this.amountImps + this.narrationImps +this.userName+this.otpImps+this.impsP2AOrP2P+this.mmidImps+this.nickNameImps);

        request.param2 = this.fromAccountNoImps;
        request.param3 = this.mobileNoImps;
        request.param4 = this.amountImps;
        request.param5 = this.narrationImps;
        request.param6 = otpDetails;
      }
      this.webService.getResponse(request, 'impsFundTransfer').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          this.accountNo = this.fromAccountNoImps;
          //this.showTransaction();
          this.isShowImps='page3';
          this.error = 'Fund Transfer Successfull! With Refrence No :' + response.param2;
        } else if (response !== null) {
          this.SubBtnDisabled=false;

          this.error = response.param1;
        } else {
           this.SubBtnDisabled=false;
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }*/
  
   go(){
     this.isShowImps='page';
  }

  back1() {
    this.error = '';
    this.isShowImps = 'page';
    this.fromAccountNoImps = '';
    this.nickNameImps = '';
    this.toAccountNoImps = '';
    this.amountImps = '';
    this.narrationImps = '';
    this.otpImps = '';
    this.NextBtnDisabled=false;
  }

  back2() {
    this.otpImps = '';
    this.error = '';
    this.isShowImps = 'page1';
    this.otpImpsValidate='';

    this.NextBtnDisabled=false;
  }

    allValidation() {
    this.fromAcctValidateImps();
    if (!this.disabled) {
      this.getToAccountNoImps();
      if (!this.disabled) {
        this.amounValidateImps();
      }if (!this.disabled) {
          this.NarrationValidateImps();
        }
      }
    }

  showTransaction() {
    this.error = '';
    if (this.accountNo && this.accountNo !== '') {
       this.spinnerService.show();
      this.isTrue = 'hide';
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.accountNo);
      request.param2 = this.accountNo;
      this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          this.accountInfo = response.param5;
          this.transactionList = response.param8;
          console.log('this.transactionList : ' + this.transactionList);
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  PtpValidateImps() {
    if (this.impsP2AOrP2P === undefined || this.impsP2AOrP2P === '') {
      this.ImpsP2AOrP2PValidate = 'no';
      this.disabled = true;

    }
  }
  removeMessageptpImps() {

    this.ImpsP2AOrP2PValidate = '';
    this.disabled = false;
  }
  fromAcctValidateImps() {
    if (this.fromAccountNoImps === undefined || this.fromAccountNoImps === '') {
      this.ImpsfromAccountNoValidate = 'no';
      this.disabled = true;

    }
  }
  removeMessagefromImps() {
    this.ImpsfromAccountNoValidate = '';
    this.disabled = false;
  }
  toAcctValidateImps() {
    if (this.nickNameImps === undefined || this.nickNameImps === '') {
      this.nickNameImpsValidate = 'no';
      this.disabled = true;

    }
  }
  removeMessagetoAcctImps() {
    this.nickNameImpsValidate = '';
    this.disabled = false;
  }
  amounValidateImps() {
    if (this.amountImps === undefined || this.amountImps === '') {
      this.amountNotlankImps = 'no';
      this.disabled = true;

    } else if (this.amountImps.match(this.regexpspace)) {
      this.amountmessageForSpaceImps = 'no';
      this.disabled = true;
    } else if (this.amountImps.match(this.regZeroOnly)) {
      this.amountZeroOnlyImps = 'no';
      this.disabled = true;
    } else if (!this.amountImps.match(this.curRegExp)) {
      this.notValidAmmountImps = 'no';
      this.disabled = true;
    } else if ( parseFloat(this.amountImps) <= 0) {
      this.greterThanZero = 'no';
      this.disabled = true;
    }
  }
  removeMessagetoAmountImps() {
    this.amountNotlankImps = '';
    this.amountmessageForSpaceImps = '';
    this.amountZeroOnlyImps = '';
    this.notValidAmmountImps = '';
    this.greterThanZero = '';
    this.disabled = false;
  }
  NarrationValidateImps() {
    if (this.narrationImps === undefined || this.narrationImps === '') {
      this.narrationValidateImps = 'no';
      this.disabled = true;
    }
  }
  removeMessageNarratinImps() {
    this.narrationValidateImps = '';
    this.disabled = false;
  }
  getIMPSOTPValid() {
    if (this.otpImps === undefined || this.otpImps === '') {
      this.otpImpsValidate = 'no';
      return false;
    }else if (this.otpImps.match(this.reg)) {
      this.otpImpsValidate = 'specialChar';
      return false;
    }else if (!this.otpImps.match(this.regNum)) {
      this.otpImpsValidate = 'num';
      return false;
    } else if (this.otpImps.length!=6) {
      this.otpImpsValidate = 'len';
      return false;
    }else{
      this.otpImpsValidate = '';
      return true;
    }
  }
  getIMPSOTPValid1() {
    if (this.otpImps === undefined || this.otpImps === '') {
      this.otpImpsValidate = 'no';
      this.otpdisablereq = true;
    }
  }
  getIMPSmesageOTPRemove() {
    this.otpImpsValidate = '';
    //this.error='';
    this.otpdisablereq = false;
    this.SubBtnDisabled=false;
  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/imps-transfer/imps-transfer.component.ts